import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";
import { Backdrop, CheckBadge } from "./shapes";

/**
 * Flat illustration for the iOS apps offering: an iPhone in the App Store
 * with a shipped-and-approved checkmark badge — a real launch, not a demo.
 */
export function IosIllustration() {
  return (
    <IllustrationSvg>
      {/* Soft backdrop card */}
      <Backdrop x={36} y={22} width={148} height={98} />
      {/* Phone body */}
      <rect
        x="84"
        y="8"
        width="52"
        height="104"
        rx="12"
        fill={colors.textPrimary}
      />
      <rect x="88" y="12" width="44" height="96" rx="9" fill={colors.paper} />
      {/* Notch */}
      <rect
        x="100"
        y="14"
        width="20"
        height="5"
        rx="2.5"
        fill={colors.textPrimary}
      />
      {/* App screen content */}
      <rect
        x="94"
        y="26"
        width="32"
        height="8"
        rx="4"
        fill={colors.primary}
        opacity="0.8"
      />
      <rect
        x="94"
        y="40"
        width="14"
        height="14"
        rx="4"
        fill={colors.primary}
        opacity="0.35"
      />
      <rect
        x="112"
        y="40"
        width="14"
        height="14"
        rx="4"
        fill={colors.secondary}
        opacity="0.5"
      />
      <rect
        x="94"
        y="58"
        width="14"
        height="14"
        rx="4"
        fill={colors.paper}
        stroke={colors.success}
        strokeOpacity="0.3"
      />
      <rect
        x="112"
        y="58"
        width="14"
        height="14"
        rx="4"
        fill={colors.primary}
        opacity="0.55"
      />
      <rect
        x="94"
        y="78"
        width="32"
        height="5"
        rx="2.5"
        fill={colors.divider}
      />
      <rect
        x="94"
        y="88"
        width="24"
        height="5"
        rx="2.5"
        fill={colors.divider}
      />
      {/* Home indicator */}
      <rect
        x="100"
        y="100"
        width="20"
        height="3.5"
        rx="1.75"
        fill={colors.divider}
      />
      {/* Shipped checkmark badge */}
      <CheckBadge cx={148} cy={34} r={16} fill={colors.secondary} />
      {/* Star rating dots */}
      <circle cx="56" cy="92" r="3.5" fill={colors.warning} />
      <circle cx="66" cy="92" r="3.5" fill={colors.warning} />
      <circle cx="76" cy="92" r="3.5" fill={colors.warning} opacity="0.45" />
    </IllustrationSvg>
  );
}
